/**
 * Logger Utility
 * Centralized logging that respects environment settings
 * Prevents sensitive data leakage in production
 */

import { reportError } from '../monitoring/sentry';

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Logger object with environment-aware methods
 */
export const logger = {
  /**
   * Log information (only in development)
   * @param {...any} args - Arguments to log
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log('[LOG]', ...args);
    }
  },

  /**
   * Log errors (always logged, but formatted)
   * @param {...any} args - Arguments to log
   */
  error: (...args) => {
    console.error('[ERROR]', ...args);
    const error = args.find((a) => a instanceof Error);
    if (error) {
      const message = args.filter((a) => typeof a === 'string').join(' ');
      reportError(error, message ? { extra: { log_message: message } } : undefined);
    }
  },

  /**
   * Log warnings (only in development)
   * @param {...any} args - Arguments to log
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  },

  /**
   * Log debug information (only in development)
   * @param {...any} args - Arguments to log
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
  },

  /**
   * Log info (only in development)
   * @param {...any} args - Arguments to log
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args);
    }
  },
};

export default logger;










